import React from 'react';
import UserTable from '../../Components/UserTable';
import MainLayout from '../../Components/Layout/MainLayout/MainLayout';

const Users = () => {
  return (
    <MainLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">User Management</h1>
        <p className="text-sm text-muted-foreground mt-1">View and manage system users</p>
      </div>
      <UserTable />
    </MainLayout>
  );
};

export default Users;
